import TextInput from "../inputs/TextInput";
import { TextInputFieldsetProps } from "./FieldsetProps";
import { TextInputField } from "../inputs/InputProps";

import "./Fieldset.scss";

const TotalPages: React.FC<TextInputFieldsetProps> = ({ textInputValue, setInputValue }) => {
    const textField: TextInputField = {
        id: "0",
        labelHidden: false,
        label: "Total Pages:",
        type: "number",
        min: "1",
        max: "9999999999",
    };

    return (
        <div className="fee-calc-fieldset">
            <TextInput
                value={textInputValue}
                handleFieldChange={setInputValue}
                fieldsetId="TotalPages"
                field={textField}
            />
        </div>
    );
};

export default TotalPages;
